import React from 'react';
import { haptic } from '../utils/vibration';
import yandexIcon from '../assets/images/yandex_icon.svg';
import osmIcon from '../assets/images/osm_icon.svg';

export const MAP_PROVIDER_STORAGE_KEY = 'bw_preferred_map_provider';

export const getStoredMapProvider = () => {
  try {
    const saved = localStorage.getItem(MAP_PROVIDER_STORAGE_KEY);
    return saved === 'osm' ? 'osm' : 'yandex';
  } catch {
    return 'yandex';
  }
};

export const setStoredMapProvider = (provider) => {
  try {
    const safeProvider = provider === 'osm' ? 'osm' : 'yandex';
    localStorage.setItem(MAP_PROVIDER_STORAGE_KEY, safeProvider);
  } catch (e) {
    console.warn('Не удалось сохранить выбор провайдера карт:', e);
  }
};

/**
 * Кнопка переключения провайдера карт (Яндекс / OpenStreetMap).
 * Выполнена в едином стиле кнопок на карте: квадратная со скруглением rounded-2xl,
 * с иконкой текущей карты, при нажатии переключает карту и меняет иконку.
 */
const MapProviderToggle = ({ provider = 'yandex', onChange, className = '' }) => {
  const isOsm = provider === 'osm';
  const nextProvider = isOsm ? 'yandex' : 'osm';

  const handleToggle = () => {
    haptic('selection');
    setStoredMapProvider(nextProvider);
    if (typeof onChange === 'function') {
      onChange(nextProvider);
    }
  };

  const label = isOsm
    ? 'Карта: OpenStreetMap (нажмите для переключения на Яндекс)'
    : 'Карта: Яндекс (нажмите для переключения на OpenStreetMap)';

  const sizeClasses = className || 'h-10 w-10';

  return (
    <button
      type="button"
      onClick={handleToggle}
      className={`inline-flex items-center justify-center rounded-2xl border border-gray-200 bg-white/95 text-gray-700 shadow-sm backdrop-blur transition-all active:scale-95 hover:bg-white dark:border-gray-700 dark:bg-gray-900/95 dark:text-gray-200 dark:hover:bg-gray-900 ${sizeClasses}`}
      title={label}
      aria-label={label}
    >
      <img
        src={isOsm ? osmIcon : yandexIcon}
        alt={isOsm ? 'OpenStreetMap' : 'Яндекс'}
        className="h-5 w-5 object-contain"
      />
    </button>
  );
};

export default MapProviderToggle;
